import { PATHWAY } from "@/constants/testIds";
import { LAB_OUTPUTS, THOUGHT_LEADERSHIP_BULLETS } from "@/lib/pathwayData";
import { SectionEyebrow } from "@/components/pathway/Journey";

export default function ThoughtLeadershipAndOutputs() {
  return (
    <section id="outputs" className="border-t hairline bg-[#0a0a0a]">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <div
          data-testid={PATHWAY.thoughtLeadershipPanel}
          className="grid gap-12 md:grid-cols-[1.2fr_1fr] md:gap-20"
        >
          <div>
            <SectionEyebrow>IV. Sponsor thought leadership</SectionEyebrow>
            <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-neutral-50 sm:text-4xl lg:text-5xl">
              For specialty insurers: sponsor the adoption pathway for new
              risks.
            </h2>
            <p className="mt-8 text-[16px] leading-relaxed text-neutral-300">
              Specialty insurers are often asked to underwrite risks before the
              operating evidence, governance model or adoption pathway is
              mature. Emerging Risk Lab Pathway gives a sponsor a safe way to
              convene that market conversation: a synthetic-first playground
              where brokers, clients, universities, technology partners and
              insurers can examine how a new risk might be governed, evidenced
              and moved toward insurability.
            </p>

            <ul className="mt-10 border-t hairline">
              {THOUGHT_LEADERSHIP_BULLETS.map((b, i) => (
                <li
                  key={b}
                  className="grid grid-cols-[40px_1fr] items-baseline gap-4 border-b hairline py-5"
                >
                  <span className="font-mono text-[10px] tracking-[0.24em] text-amber-600">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-[15px] leading-relaxed text-neutral-200">
                    {b}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <aside className="md:sticky md:top-24 md:self-start">
            <SectionEyebrow>V. Lab outputs</SectionEyebrow>
            <h3 className="mt-4 font-serif text-2xl leading-tight text-neutral-50">
              Deliverables a sponsor receives.
            </h3>
            <ol
              data-testid={PATHWAY.labOutputsList}
              className="mt-8 border-t hairline"
            >
              {LAB_OUTPUTS.map((o, i) => (
                <li
                  key={o}
                  className="grid grid-cols-[60px_1fr] gap-3 border-b hairline py-4"
                >
                  <span className="font-mono text-[11px] tracking-[0.2em] text-neutral-500">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-[14px] leading-relaxed text-neutral-200">
                    {o}
                  </span>
                </li>
              ))}
            </ol>
          </aside>
        </div>
      </div>
    </section>
  );
}
